module.exports = __webpack_public_path__ + "static/img/4_v2.7faf1b49.png";